export function createDocumentName(namespace: string, slug: string) {
  return `${namespace}/${slug}`
}
